var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1657 12.4608H2.92773L5.56233 9.31977L5.57439 9.30771L10.6929 3.20655L12.5437 1L22.1657 12.4608Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4916 12.4609H5.61328V22.728H19.4916V12.4609Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0592 22.728H2.04276C1.33688 22.728 0.764648 23.3003 0.764648 24.0061V24.0122C0.764648 24.718 1.33688 25.2903 2.04276 25.2903H23.0592C23.7651 25.2903 24.3373 24.718 24.3373 24.0122V24.0061C24.3373 23.3003 23.7651 22.728 23.0592 22.728Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4277 16.6567H10.6777V22.7278H14.4277V16.6567Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 9.04251C13.1268 9.04251 13.5938 8.57555 13.5938 7.99953C13.5938 7.4235 13.1268 6.95654 12.5508 6.95654C11.9748 6.95654 11.5078 7.4235 11.5078 7.99953C11.5078 8.57555 11.9748 9.04251 12.5508 9.04251Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.694 3.20654L5.57553 9.30771L5.56348 9.31977V3.20654H10.694Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoem);
export default __webpack_public_path__ + "static/media/hoem.73bba2b4640b1812127a913c6a3f62c1.svg";
export { ForwardRef as ReactComponent };